<template>
  <v-app>
    <!--v-navigation-drawer app>nav</v-navigation-drawer-->
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <router-link
          to="/"
        >
          <v-btn
            color="blue"
            flat
            round
          >
            Accueil
          </v-btn>
        </router-link>
        <router-link
          to="/poesie"
        >
          <v-btn
            color="blue"
            flat
            round
          >
            Poesie
          </v-btn>
        </router-link>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              v-on="on"
            >
              Mathématiques
            </v-btn>
          </template >
          <v-list row>
            <v-list-item>
              <router-link
                to="/heure"
              >
                <v-btn
                  color="blue"
                  flat
                  round
                >
                  Heure
                </v-btn>
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link
                to="/nombre"
              >
                <v-btn
                  color="blue"
                  flat
                  round
                >
                  Nombres
                </v-btn>
              </router-link>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-title>
    </v-toolbar>
    <v-content transition="slide-x-transition">
      <router-view />
    </v-content>
    <v-footer
      height="auto"
      color="primary lighten-1"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          primary
          lighten-2
          py-3
          text-xs-center
          white--text
          xs12
        >
          &copy;2018 —
          <strong>Vuetify</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import router from "./router";
import Accueil from "@/components/Accueil";
import Heure from "@/components/maths/Heure";
import store from "@/store";
import '@mdi/font/css/materialdesignicons.css'// Ensure you are using css-

export default {
  created() {},
  name: "App",
  components: {
  },
  computed: {
    menus: {
      get() {
        return router.options.routes;
      }
    },
    user: {
      get() {
        return store.state.user;
      }
    },
    configuration: {
      get() {
        return store.state.configuration;
      }
    }
  },
  methods :{
    logout(){
      store.dispatch('logOut')
    }
  }
};
</script>
